import { PropsWithChildren } from 'react'

const SvgChartSettingsCard = (props: PropsWithChildren) => {
  return (
    <div
      style={{
        border: '1px solid var(--border-secondary-color)',
        backgroundColor: 'var(--bg-layout)',
        borderRadius: '8px',
        padding: '16px',
        paddingTop: '12px',
      }}
    >
      {props.children}
    </div>
  )
}

export default SvgChartSettingsCard
